
import {Component, Vue} from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import ProductItem from "@/views/invoiceBookingOrder/component/ProductItem.vue";
import InvoiceAmountDetail from "@/views/invoiceBookingOrder/component/InvoiceAmountDetail.vue";
import BindInvoice from "@/views/invoiceBookingOrder/component/BindInvoice.vue";
import {
  detailInvoiceBookingOrder, detailInvoiceBookingOrderNative,
  markAsNoInvoice,
  pageInvoiceBookingOrderDetail,
  pageInvoiceBookingOrderDetailNative, queryDataSourceMode,
  queryFactoryInvoiceAllocateStatus,
  revertMarkAsNoInvoice,
  revertReplaceFactoryInvoice,
  updateFactoryInvoiceInvoiceRemark
} from "@/api/invoice/index";
import {getUserByRole} from "@/api/users";
import {deepClone} from "@/utils/deepClone";
import {exportJson2Excel} from "@/utils/excel";
import {formatJson} from "@/utils";
import Invoice from "@/views/invoice/index.vue";
import InvoiceDesc from "@/views/invoiceBookingOrder/component/InvoiceDesc.vue";
import Template from "@/views/system-management/template/index.vue";
import DismantleInvoice from "@/views/invoiceBookingOrder/component/DismantleInvoice.vue";
import ChangeInvoice from "@/views/invoiceBookingOrder/component/ChangeInvoice.vue";
import OriginInfo from "@/views/invoiceBookingOrder/component/OriginInfo.vue";

@Component({
  name: "invoiceBookingOrder",
  components: {
    OriginInfo,
    ChangeInvoice,
    DismantleInvoice,
    Template,
    InvoiceDesc,
    Invoice,
    BindInvoice,
    InvoiceAmountDetail,
    ProductItem,
    Pagination,
  },
})
export default class extends Vue {
  private bookingOrderId = "";
  private bookingOrderCode = "";
  private company = "";
  private current: any = {};
  private showRemark = false;
  private remark = "";
  private list = [
    {
      label: "报关合同号",
      prop: "code",
      key: "code"
    },
    {
      label: "开票总金额",
      prop: "invoiceAmount",
      key: "invoiceAmount"
    },
    {
      label: "已开票金额",
      prop: "allocateInvoiceAmount",
      key: "allocateInvoiceAmount"
    },
    {
      label: "未开票金额",
      prop: "unAllocateInvoiceAmount",
      key: "unAllocateInvoiceAmount"
    },
    {
      label: "已绑定金额",
      prop: "bindAmount",
      key: "bindAmount"
    },
    {
      label: "销售员",
      prop: "seller",
      key: "seller"
    },
    {
      label: "物流员",
      prop: "logistics",
      key: "logistics"
    },
    {
      label: "财务状态",
      prop: "taxRefundStatus",
      key: "taxRefundStatus"
    },
  ];
  private readForm = {
    "code": "123456789",
    "invoiceAmount": 10000.00,
    "allocateInvoiceAmount": 8000.00,
    "unAllocateInvoiceAmount": 2000.00,
    "bindAmount": 7000.00,
    "seller": "张三",
    "logistics": "李四",
    "taxRefundStatus": "待退税",
  }
  private searchForm = [
    {
      label: "开票资料号",
      prop: "code",
      key: "code",
      type: "input",
      placeholder: "请输入开票资料号",
    },
    {
      label: "采购员",
      prop: "purchaser",
      key: "purchaser",
      type: "select",
      value: "",
      options: [],
      clearable: true,
      resetKey: {label: "name", value: "value"},
    },
    {
      label: "开票状态",
      prop: "invoiceState",
      key: "invoiceState",
      type: "select",
      options: [],
      placeholder: "请选择开票状态",
      resetKey: {label: "desc", value: "name"},
    },
    {
      label: "发票号码",
      prop: "invoiceNumber",
      key: "invoiceNumber",
      type: "input",
      placeholder: "请输入发票号码",
    },
    {
      label: "应付会计",
      prop: "accountant",
      key: "accountant",
      type: "select",
      value: "",
      options: [],
      clearable: true,
      resetKey: {label: "name", value: "value"},
    },
    {
      label: "采购订单号码",
      prop: "purchaseOrderCode",
      key: "purchaseOrderCode",
      type: "input",
      placeholder: "请输入采购订单号码",
    },
    {
      label: "装箱单号",
      prop: "packingListCode",
      key: "packingListCode",
      type: "input",
      placeholder: "请输入装箱单号",
    },
  ]
  private queryForm = {
    bookingOrderId: "",
    code: "",
    purchaser: "",
    invoiceStatus: "",
    invoiceNumber: "",
    accountant: "",
    purchaseOrderCode: "",
    packingListCode: "",
  }
  private selection = []
  private loading = true;

  //开票资料号码	供应商简称	开票品名	开票金额	开票数量	开票单位	采购员	应付会计	开票状态	采购订单号	装箱单号	操作		备注（文本）
  private tableCol = [
    {
      label: "开票资料号码",
      prop: "code",
      key: "code",
      width: 200,
    },
    {
      label: "供应商简称",
      prop: "supplierAbb",
      key: "supplierAbb",
    },
    {
      label: "开票品名",
      prop: "productNames",
      key: "productNames",
    },
    {
      label: "开票金额",
      prop: "totalAmount",
      key: "totalAmount",
      type: 'link'
    },
    {
      label: "开票数量",
      prop: "number",
      key: "number",
    },
    {
      label: "开票单位",
      prop: "unit",
      key: "unit",
    },
    {
      label: "采购员",
      prop: "purchaser",
      key: "purchaser",
    },
    {
      label: "应付会计",
      prop: "accountant",
      key: "accountant",
    },
    {
      label: "开票状态",
      prop: "invoiceState",
      key: "invoiceState",
      type: "custom",
      slot: "invoiceState0"
    },
    {
      label: "采购订单号",
      prop: "purchaseOrderCode",
      key: "purchaseOrderCode",
    },
    {
      label: "装箱单号",
      prop: "packingListCode",
      key: "packingListCode",
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      type: "remark",
      length: 255,
    },
  ]
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };
  private dataMode = "";

  async created() {
    this.bookingOrderId = this.$route.params.id;
    this.bookingOrderCode = this.$route.query.bookingOrderCode as string;
    this.company = this.$route.query.company as string;
    await this.getDataMode();
    this.getList()
    this.getDetail()
    this.getUserList();
    await this.fillSearchParamForAllocateStatusOptions();
  }

  async activated() {
    this.bookingOrderId = this.$route.params.id;
    this.bookingOrderCode = this.$route.query.bookingOrderCode as string;
    this.company = this.$route.query.company as string;
    await this.getDataMode();
    this.getList()
    this.getDetail()
    this.getUserList();
    await this.fillSearchParamForAllocateStatusOptions();
  }

  private async getDataMode() {
    const res = await queryDataSourceMode() as any;
    this.dataMode = res.name;
  }

  public async fillSearchParamForAllocateStatusOptions() {
    const options:any = await queryFactoryInvoiceAllocateStatus();
    this.searchForm[2].options = options;
  }

  public querySearch(data) {
    this.table.pageNumber = 1;
    this.queryForm = data && data !== "reset" ? data : {};
    this.getList();
  }

  public handleDownload() {
    const list = deepClone(this.table.list
        .filter(item => item.splitResult?.name !== 'PARENT')
        .map(item => {
          if (item.replaceStatus?.desc !== '空') {
            return { ...item, invoiceState: item.invoiceState?.desc || "-" }
          } else {
            return {
              code: '空', supplierAbb: '', productNames: '', totalAmount: '', number: '', unit: '', purchaser: '',
              accountant: '', invoiceState: '', purchaseOrderCode: '', packingListCode: '', remark: ''
            }
          }
        }));
    const headers = this.tableCol.map((v) => v.label);
    const fieldNames = this.tableCol.map((v) => v.key);
    exportJson2Excel(
        headers,
        formatJson(fieldNames, list),
        `${this.bookingOrderCode}-${new Date()}`
    );
  }

  public handleInvoice({row}) {
    this.$router.push({
      name: "Invoice",
      query: {
        bookingOrderId: this.bookingOrderId,
        bookingOrderCode: this.bookingOrderCode
      }
    })
  }

  public handleInvoiceAmount(row, prop) {
    (this.$refs['invoiceDescRef'] as InvoiceDesc)
        .openDialog({id: row.id, type: "FACTORY_INVOICE"})
  }

  public linkClick(row) {
    (this.$refs['invoiceAmountDetailRef'] as InvoiceAmountDetail)
        .openDialog({id: row.id, type: "FACTORY_INVOICE"});
  }

  public async handleRemark() {
    await updateFactoryInvoiceInvoiceRemark(this.current.id, this.remark).then(() => {
      this.$notify({
        title: "提示",
        message: "修改备注成功！",
        type: "success",
        duration: 2000,
      });
      this.showRemark = false;
      this.getList()
    })
  }

  public handleProductItem(row) {
    (this.$refs['productItemRef'] as ProductItem)
        .openDialog({id: row.bid, factoryName: row.factoryName, productName: row.productNames})
  }

  public handleBind(row) {
    const options = {
      title: '绑定发票'
    };
   let newRow =  {...row, company: this.company};
    (this.$refs['bindInvoiceRef'] as BindInvoice).openDialog(newRow, options)
  }

  public handleEdit({row}) {
    const options = {
      title: '编辑',
    };
    (this.$refs['bindInvoiceRef'] as BindInvoice).openDialog(row, options)
  }

  public handleDocumentFlow(row) {
    this.$router.push({
      name: "DocumentFlow",
      params: {type: "FACTORY_INVOICE", documentId: row.id},
    });
  }

  public handleSelectionChange(selection) {
    this.selection = selection
  }

  public getOriginInfo(row) {
    (this.$refs['originInfoRef'] as OriginInfo).openDialog(row);
  }

  public handleDismantleData(row) {
    (this.$refs['dismantleInvoiceRef'] as DismantleInvoice).openDialog(row)
  }

  public handleChangeData(row) {
    (this.$refs['changeInvoiceRef'] as ChangeInvoice).openDialog(row)
  }

  private handleCancelChangeData(row) {
    this.$confirm('是否取消换资料?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(async () => {
      await revertReplaceFactoryInvoice(row.originalFactoryInvoiceId);
      this.$message({
        type: 'success',
        message: '取消换资料成功!'
      });
      this.getList();
    })
  }

  private handleCommand(command) {
    if (command.action === "发票列表") {
      this.handleBind(command.row)
    }
    if (command.action === "无发票") {
      this.$confirm(`确定标记${command.row.code}为无发票?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        markAsNoInvoice(command.row.id).then(() => {
          this.$message({
            type: 'success',
            message: '标记无发票成功!'
          });
          this.getList();
        });
      });
    }
    if (command.action === "取消无发票(经理)") {
      this.$confirm(`${command.row.code}确定取消无发票?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        revertMarkAsNoInvoice(command.row.id).then(() => {
          this.$message({
            type: 'success',
            message: '取消无发票成功!'
          });
          this.getList();
        });
      });
    }
  }

  public getList() {
    this.loading = true
    this.queryForm.bookingOrderId = this.bookingOrderId
    if (this.dataMode === "ACTUAL") {
      pageInvoiceBookingOrderDetail(this.queryForm,
          {
            pageNumber: this.table.pageNumber,
            pageSize: this.table.pageSize
          })
          .then((res) => {
                console.log(res);
                this.table.total = Number(res.total);
                this.table.list = res.content;
              }
          )
          .finally(() => this.loading = false)
    } else {
      pageInvoiceBookingOrderDetailNative(this.queryForm,
          {
            pageNumber: this.table.pageNumber,
            pageSize: this.table.pageSize
          })
          .then((res) => {
                console.log(res);
                this.table.total = Number(res.total);
                this.table.list = res.content;
              }
          )
          .finally(() => this.loading = false)
    }
  }

  public getDetail() {
    if (this.dataMode === "ACTUAL") {
      detailInvoiceBookingOrder(this.bookingOrderId)
          .then((res) => {
                this.readForm.code = res.code;
                this.readForm.invoiceAmount = res.invoiceTotalAmount.toFixed(2);
                let seller = res.seller
                if (res.sellerAssistant) {
                  seller = seller + "/" + res.sellerAssistant;
                }
                this.readForm.seller = seller;
                this.readForm.allocateInvoiceAmount = res.allocateAmount.toFixed(2);
                this.readForm.bindAmount = res.bindInvoiceAmount.toFixed(2);
                this.readForm.unAllocateInvoiceAmount = res.unAllocateAmount.toFixed(2);
                this.readForm.logistics = res.logistics;
                this.readForm.taxRefundStatus = res.taxRefundStatus;
              }
          );
    } else {
      detailInvoiceBookingOrderNative(this.bookingOrderId)
          .then((res) => {
                this.readForm.code = res.code;
                this.readForm.invoiceAmount = res.invoiceTotalAmount.toFixed(2);
                let seller = res.seller
                if (res.sellerAssistant) {
                  seller = seller + "/" + res.sellerAssistant;
                }
                this.readForm.seller = seller;
                this.readForm.allocateInvoiceAmount = res.allocateAmount.toFixed(2);
                this.readForm.bindAmount = res.bindInvoiceAmount.toFixed(2);
                this.readForm.unAllocateInvoiceAmount = res.unAllocateAmount.toFixed(2);
                this.readForm.logistics = res.logistics;
                this.readForm.taxRefundStatus = res.taxRefundStatus;
              }
          );
    }
  }

  public getUserList() {
    getUserByRole('采购员')
        .then((data) => {
          this.searchForm[1].options = data;
        })
    getUserByRole('应付会计')
        .then((data) => {
          this.searchForm[4].options = data;
        })
  }

  private async dismantleInvoiceDone() {
    this.getDetail();
    this.getList();
  }
}
